import { render, staticRenderFns } from "./TaxpayerIdNumber.vue?vue&type=template&id=1926cef5&"
import script from "./TaxpayerIdNumber.vue?vue&type=script&lang=js&"
export * from "./TaxpayerIdNumber.vue?vue&type=script&lang=js&"
import style0 from "./TaxpayerIdNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports